module.exports = __webpack_public_path__ + "img/bereniceinsta.bb7885e6.jpg";